var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 987.03 155.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212121;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 740.32,
    cy: 75.66,
    r: 75.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 740.14,
    cy: 75.68,
    r: 72.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M723.65,5.33a70.6,70.6,0,0,1,8.15-1.42c.39-.05.79-.1,1.17-.13a72.33,72.33,0,0,1,74,44.46,72.81,72.81,0,0,1,3.49,10.95A71.91,71.91,0,0,1,806.17,105c-.16.36-.32.71-.5,1.06h0a72.13,72.13,0,0,1-38.29,36.53q-1.27.51-2.58,1A72.67,72.67,0,0,1,740.33,148h0c-.85,0-1.7,0-2.55,0a72.38,72.38,0,0,1-54.62-27.8c-.26-.32-.51-.64-.76-1A72.3,72.3,0,0,1,723.65,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M780.33,122.73l-16-15.83s10.2-15.64,12.51-29.24l24-2.15a49,49,0,0,1,1.55,28.38S791,117.59,780.33,122.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M716.89,131.29l-27.68-13.7-2.72-28.11s20.32-2.93,26.27-5.34c0,0,13.48,20.08,20.37,26C733.13,110.15,726.13,124.63,716.89,131.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M757.31,50.65,726.2,54.48,711.15,30.29A63.56,63.56,0,0,1,734.8,12.91s24.2,7.58,29.47,12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.34,31.05l2.39,4.74.38.78c-.14.15-.29.31-.44.49h0c-5.26,5.9-9.75,19.15-11,23-.23.68-.34,1.07-.34,1.07h-.63l-4.34-.06A71.92,71.92,0,0,1,683.34,31.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.91,19A71.85,71.85,0,0,1,807,48.24l-1.19,2.37-1.1,2.18-.14-.31h0c-1.13-2.51-8.76-18.8-19.62-26.79,0,0,0,0-.06,0V24.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.56,92l-.62.27c-.76-.14-11.24-9.9-15.4-32l1.15-.22c4.16,22.1,14.5,31.09,14.6,31.15l-.29.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M713.26,29.4l.11,1.16c-13.93,1.26-29.22,7-29.37,7.09l-.41-1.09C683.74,36.5,699.17,30.68,713.26,29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.59,53.61a81.62,81.62,0,0,0-14.31,34.71l-1.15-.18a82.58,82.58,0,0,1,14.55-35.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M766.89,106.91c-.2.06-19.77,6.61-35.2,4.13l.18-1.15c15.15,2.44,34.45-4,34.64-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M716.85,129.64s.28.4.83,1.05c2.32,2.78,9.53,10.55,22.64,17.26-.85,0-1.7,0-2.55,0-12.52-6.81-19.29-14.4-21.26-16.81-.39-.49-.59-.76-.6-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.06,116.15l.38,1.11-1.72.59-6.57,2.26c-.26-.32-.51-.64-.76-1l6.74-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M780.63,120.89l1.08.44c-.12.3-.24.6-.37.89-3.77,8.72-9.77,16-14,20.39q-1.27.51-2.58,1c3.91-3.88,10.88-11.62,15.18-21.21C780.21,121.9,780.42,121.39,780.63,120.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M801,103.32l1.47.48,3.74,1.21c-.16.36-.32.71-.5,1.06l-4-1.3-1.07-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.68,48.35c1,8.56-4.73,28.67-5,29.53l-1.12-.32c.06-.21,5.89-20.75,4.94-29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.1,78.53l-1.09.41c-.07-.18-7-18.13-20.43-28.55l.71-.92C771,60.09,778,78.34,778.1,78.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M786.2,24.8l-.32,1.13c-9.57-2.72-24.08.62-24.22.65l-.27-1.13C762,25.31,776.34,22,786.2,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M731.8,3.91c.39-.05.79-.09,1.18-.11L735.66,14l-.57.14,0,0-.53.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.28,2.23c12.17,0,20.28,8.11,20.28,20.28V72.4L87.21,11c4.46-5.88,10.14-8.72,17-8.72,12.17,0,20.28,8.11,20.28,20.28V132.23c0,12.17-8.11,20.28-20.28,20.28S84,144.4,84,132.23V82.14L38.33,142.37c-5.07,6.69-11.15,10.14-18,10.14C8.11,152.51,0,144.4,0,132.23V22.51C0,10.34,8.11,2.23,20.28,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.63,132.23c0,12.17-8.11,20.28-20.28,20.28s-20.28-8.11-20.28-20.28V93.9h-43.4v38.33c0,12.17-8.11,20.28-20.28,20.28s-20.28-8.11-20.28-20.28V22.51c0-12.17,8.11-20.28,20.28-20.28s20.28,8.11,20.28,20.28V57.39h43.4V22.51c0-12.17,8.11-20.28,20.28-20.28s20.28,8.11,20.28,20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.67,40.56a35.7,35.7,0,0,0-26.16,10.95,35.65,35.65,0,0,0-10.75,26.16,36.69,36.69,0,0,0,36.91,36.91,40.25,40.25,0,0,0,30-12.57c8.31-8.92,19.87-8.92,28.59-.2s8.93,20.08.21,29c-13.8,14.6-35.5,24.34-58.82,24.34-21.29,0-39.55-7.51-54.76-22.72S333.2,99,333.2,77.67s7.5-39.54,22.71-54.75S389.38,0,410.67,0c23.53,0,45.23,10.34,59.22,25.76,8.32,8.92,8.32,20.28-.4,28.59s-20.69,8.32-28.8-.61C432.78,45,422.84,40.56,410.67,40.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.92,76.86l38.74,40.77c8.31,8.92,8.11,20.48-.82,28.79s-20.48,8.12-28.79-.81l-39.75-42v28.6c0,12.17-8.12,20.28-20.28,20.28s-20.28-8.11-20.28-20.28V22.51c0-12.17,8.11-20.28,20.28-20.28s20.28,8.11,20.28,20.28V49.89L596.64,9.13c8.72-8.72,20.08-8.72,28.8-.41s8.92,20.08.61,28.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.21,2.23H939c13.59,0,25.15,4.87,34.28,14.6C982.36,26.36,987,39.34,987,55.37c0,17.64-4.46,31.43-13.59,41S953,110.73,939,110.73H904.49v21.5c0,12.17-8.12,20.28-20.28,20.28s-20.29-8.11-20.29-20.28V22.51C863.92,10.34,872,2.23,884.21,2.23Zm20.28,72h24.33c10.75,0,17.65-5.89,17.65-17.85,0-10.55-7.1-17.64-17.65-17.64H904.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.9b0094c8e0e9c6857fed9c75dc951fb4.svg";
export { ForwardRef as ReactComponent };